// extracted by mini-css-extract-plugin
export default {"card":"S4-z"};